import {
  isJLExclusive,
  isPriceMatch,
  isReducedToClear,
} from './specialMessage';

const formatThenPrice = (price) => {
  if (!price.then2) {
    return (price.then1 || '').toString();
  }
  if (!price.then1) {
    return '';
  }
  return `${price.then1}, ${price.then2}`;
};

export const mapProduct = (product, index) => {
  const data = {};
  const {
    id,
    productId,
    priceRange,
    price: priceValue = {
      currency: '',
      now: '',
      then1: '',
      then2: '',
      was: '',
    },
    displaySpecialOffer = '',
    outOfStock = '',
    colorSwatches = [],
    rating = {
      averageRating: '',
      reviews: '',
    },
    defaultSkuId,
    isMultiSku,
    adId,
    promoClassifications,
  } = product;
  const price = priceRange || priceValue;
  const { now: priceNow = '', was: priceWas = '' } = price;
  const priceThen = formatThenPrice(price);

  if (index > -1) {
    data.listPosition = index + 1;
  }

  data.productId = id || productId;

  if (adId) {
    data.citrusAdId = adId;
  }

  if (promoClassifications?.length) {
    data.promotionClassifications = promoClassifications;
  }

  return {
    currency: 'gbp',
    ...data,
    sku: defaultSkuId,
    hasSpecialOfferText: displaySpecialOffer !== '',
    isJLExclusive: isJLExclusive(displaySpecialOffer),
    isOutOfStock: outOfStock,
    isPriceMatch: isPriceMatch(displaySpecialOffer),
    isReducedToClear: isReducedToClear(displaySpecialOffer),
    numColourSwatches: colorSwatches?.length,
    numReviews: rating?.reviews,
    rating: rating?.averageRating,
    priceNow,
    priceThen,
    priceWas,
    isMultiSku,
  };
};
